import { actions } from './contacts.actions'
import { getters } from './contacts.getters'
import { state } from './contacts.state'
import { mutations } from './contacts.mutations'

export default { actions, getters, state, mutations, namespaced: true }
